const WAIR_TRIGGER_SELECTOR = '[data-wair-trigger="true"]';
const WAIR_ACCORDION_LINK_SELECTOR = 'a[href="#find-my-size"]';

const WAIR_CTA_SELECTORS = [
  '.predict-placement .wair-launch-btn',
  '.predict-placement .wair-rec-btn',
  '.predict-placement .wair-predict-button',
  '.predict-placement #wair-fit-advisor',
  '.bb-recommendation.tf_sizepopup > div',
];

function findWairTarget(trigger) {
  const actions = trigger.closest('.variant-option__size-actions');

  if (actions) {
    for (const selector of WAIR_CTA_SELECTORS) {
      const target = actions.querySelector(selector);
      if (target instanceof HTMLElement) return target;
    }
  }

  for (const selector of WAIR_CTA_SELECTORS) {
    const target = document.querySelector(selector);
    if (target instanceof HTMLElement) return target;
  }

  return null;
}

function findPrimaryTrigger(trigger) {
  const primaryTrigger = document.querySelector('.variant-option__size-actions [data-wair-trigger="true"]');

  if (primaryTrigger instanceof HTMLElement && primaryTrigger !== trigger) {
    return primaryTrigger;
  }

  return null;
}

function clickWairTarget(trigger, attempt = 0) {
  const primaryTrigger = findPrimaryTrigger(trigger);

  if (primaryTrigger) {
    primaryTrigger.click();
    return;
  }

  const target = findWairTarget(trigger);

  if (target) {
    target.click();
    return;
  }

  if (attempt >= 6) return;

  window.setTimeout(() => {
    clickWairTarget(trigger, attempt + 1);
  }, 250);
}

function bindTrigger(trigger) {
  if (trigger.dataset.wairBound === 'true') return;

  trigger.dataset.wairBound = 'true';
  trigger.addEventListener('click', (event) => {
    event.preventDefault();
    clickWairTarget(trigger);
  });
}

function bindAllTriggers(root = document) {
  root.querySelectorAll(WAIR_TRIGGER_SELECTOR).forEach(bindTrigger);
  root.querySelectorAll(WAIR_ACCORDION_LINK_SELECTOR).forEach(bindTrigger);
}

bindAllTriggers();

const observer = new MutationObserver(() => {
  bindAllTriggers();
});

observer.observe(document.documentElement, {
  childList: true,
  subtree: true,
});
